<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      is_modal_open: false,
    }
  },

  props: [
    'is_small'
  ],

  methods: {
    ...mapActions([
      'setIsTerminating'
    ]),

    showModal: function (event) {
      this.is_modal_open = true
      // $('[data-toggle="tooltip"]').blur()
      // $('#reservationTerminateModal').modal('show')
    },

    terminateLab: function (event) {
      let payload = { is_terminating: true }
      this.setIsTerminating(payload)

      window.location.href = Labstack.url + '/me/reservation/terminate'
    },
  },

  computed: {
    ...mapState({
      reservation_transaction: state =>
        state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        ),
      infrastructure_pod: state => {
        let transaction = state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        )
        return state.infrastructure.infrastructure_pods.find(
          p => p.id === transaction.relationships.infrastructure_pod.data.id
        )
      },
      is_terminating: state =>
        state.reservation.current.is_terminating
    }),

    isDisabled: function () {
      return this.is_terminating ||
      (
        this.reservation_transaction &&
        // Pending status
        this.infrastructure_pod.attributes.pod_status == 2
      )
    }
  }
}
</script>

<template>
  <span>
    <button
      @click="showModal"
      :disabled="isDisabled"
      :class="{ 'disabled opacity-50 cursor-not-allowed' : isDisabled, 'hover:text-white hover:no-underline hover:bg-riverbed-purple active:bg-riverbed-purple active:text-white active:no-underline focus:bg-riverbed-purple focus:text-white focus:no-underline ease-in-out duration-300 shadow md:after:absolute md:after:origin-center md:after:h-80 md:after:top-0 md:after:bottom-0 md:after:left-0 md:after:right-0 md:after:bg-riverbed-purple md:after:opacity-0 md:after:scale-x-0 md:after:ease-in-out md:after:duration-300 md:hover:after:opacity-100 md:hover:after:scale-x-110 md:hover:after:rotate-12 md:hover:after:-translate-y-1/2': ! isDisabled, 'px-2 py-1': is_small, 'px-4 py-2': ! is_small }" class="rounded-full relative inline-flex items-center mx-auto group text-center text-base font-bold uppercase whitespace-nowrap overflow-hidden border-2 border-riverbed-purple text-riverbed-purple bg-white"
    >
      <span class="relative z-10">Terminate</span>
    </button>
    <div
        v-show="is_modal_open"
        class="fixed z-50 inset-0 overflow-y-auto"
        role="dialog">
      <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" role="dialog">
        <div
            v-show="is_modal_open"
            @click="is_modal_open = false"
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            aria-hidden="true">
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

        <div
            v-show="is_modal_open"
            class="relative inline-block align-middle bg-white rounded-lg px-4 pt-4 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6"
        >
            <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-fuchsia-100">
              <svg class="h-6 w-6 text-riverbed-fuchsia" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-5">
              <h3 class="text-lg leading-6 font-bold text-gray-900" id="modal-title">Terminate Reservation</h3>
              <div class="mt-2">
                <p class="text-base text-gray-900">Please confirm that you wish to terminate your current reservation.</p>
              </div>
            </div>
            <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
              <button
                type="button"
                @click.prevent="terminateLab"
                :disabled="isDisabled"
                :class="{ 'disabled opacity-50 cursor-not-allowed' : isDisabled }"
                class="w-full rounded-full relative inline-flex justify-center group px-4 py-2 text-center text-base font-bold uppercase whitespace-nowrap overflow-hidden border-2 border-riverbed-fuchsia text-riverbed-fuchsia bg-white sm:col-start-2 hover:bg-riverbed-fuchsia hover:text-white hover:no-underline active:bg-riverbed-fuchsia active:text-white active:no-underline focus:bg-riverbed-fuchsia focus:text-white focus:no-underline ease-in-out duration-300 shadow md:after:absolute md:after:origin-center md:after:h-80 md:after:top-0 md:after:bottom-0 md:after:left-0 md:after:right-0 md:after:bg-riverbed-fuchsia md:after:opacity-0 md:after:scale-x-0 md:after:ease-in-out md:after:duration-300 md:hover:after:opacity-100 md:hover:after:scale-x-110 md:hover:after:rotate-12 md:hover:after:-translate-y-1/2">
                <span class="relative z-10 flex-1">Yes</span>
              </button>
              <button
                type="button"
                @click.prevent="is_modal_open = false"
                :disabled="isDisabled"
                :class="{ 'disabled opacity-50 cursor-not-allowed' : isDisabled }"
                class="w-full rounded-full relative inline-flex justify-center group px-4 py-2 text-center text-base font-bold uppercase whitespace-nowrap overflow-hidden border-2 border-riverbed-purple text-riverbed-purple bg-white mt-3 sm:mt-0 sm:col-start-1 hover:bg-riverbed-purple hover:text-white hover:no-underline active:bg-riverbed-purple active:text-white active:no-underline focus:bg-riverbed-purple focus:text-white focus:no-underline ease-in-out duration-300 shadow md:after:absolute md:after:origin-center md:after:h-80 md:after:top-0 md:after:bottom-0 md:after:left-0 md:after:right-0 md:after:bg-riverbed-purple md:after:opacity-0 md:after:scale-x-0 md:after:ease-in-out md:after:duration-300 md:hover:after:opacity-100 md:hover:after:scale-x-110 md:hover:after:rotate-12 md:hover:after:-translate-y-1/2">
                <span class="relative z-10 flex-1">No</span>
              </button>
            </div>
        </div>
      </div>
    </div>
  </span>
</template>
